// AI-CONTEXT: See docs/features/updates-log.md
// Vertaalt de instellingen van een organisatie naar de modulecodes waarop de
// Updates-pagina filtert.

/**
 * Bewust dezelfde gates als LeftSideBar.js: het menu toont 'Ondersteuning' bij
 * personasOn === 'flex' en 'Portfolio' bij portfolio === 'block'. Wijkt deze
 * vertaling daarvan af, dan leest iemand over een module waarvan het menu-item
 * niet eens bestaat.
 *
 * Elke vlag valt dicht bij een ontbrekende waarde — een organisatie waarvan de
 * instellingen nog niet geladen zijn krijgt dus geen enkele module mee.
 * Zie docs/pitfalls.md#state-gate-defaults-open-while-loading
 *
 * @param {object} [settings] - De uitkomst van useSettings()
 * @returns {Array<string>} Modulecodes, in vaste volgorde
 */
const activeUpdateModules = (settings) => {
    const data = settings || {}

    // ImpactFunctionality en HouseVisits worden als boolean én als string
    // weggeschreven; Settings.jsx accepteert beide vormen, dus wij ook.
    const isAan = (value) => value === true || value === 'true'

    const modules = []

    if (isAan(data.impactFunctionality)) modules.push('impactMeten')
    if (data.personasOn === 'flex') modules.push('personas')
    if (isAan(data.housevisits)) modules.push('housevisits')
    if (data.portfolio === 'block') modules.push('portfolio')

    return modules
}

export default activeUpdateModules
